import {
  PeriodicTasksQueryVariables,
  usePeriodicTasksLazyQuery,
} from "generated/graphql"
import { useEffect } from "react"

export const useAllPeriodicTasks = (variables: PeriodicTasksQueryVariables) => {
  const variableString = JSON.stringify(variables)
  const [getDetails, response] = usePeriodicTasksLazyQuery()
  useEffect(() => {
    getDetails({
      variables: {
        ...JSON.parse(variableString),
      },
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [variableString])
  return response
}
